import { FORM_BUSY } from "../actions/types";

const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action) => {

    if(action.type === FORM_BUSY)
    {
        // console.log("form action button write", action);

        if(action.payload){
            const formKey = action.payload.formKey;

            const newState = {...state};

            if(action.payload.isBusy === 1) newState[formKey] = 1;
            else delete newState[formKey];
            
            return newState;
        }
    }

    return state;
}
